import { defineStore } from 'pinia'
import QuoteService from '@/services/quotes.service.js'

export const useSubmitQuoteModalStore = defineStore('submitQuoteModal', {
    state: () => ({
        quotes: [],
    }),
    getters: {
        getQuotes: (state) => state.quotes,
    },
    actions: {
        setQuotes(quotes) {
            this.quotes = quotes
        },
        upsertQuote(quote) {
            if (!quote || !quote.id) {
                return
            }

            const existingIndex = this.quotes.findIndex((item) => item?.id === quote.id)
            if (existingIndex >= 0) {
                this.quotes.splice(existingIndex, 1, quote)
                return
            }

            this.quotes.push(quote)
        },
        cleanState() {
            this.quotes = []
        },
        async getQuotesbySearchActionId(searchActionId) {
            try {
                const data = await QuoteService.getQuotesBySearchActionId(searchActionId)
                this.setQuotes(data || [])
            } catch (error) {
                console.error('Failed to load submitted quote data', error)
                throw error
            }
        },
    },
})
